import React from "react";
import { Drawer } from "@mui/material";
import { SlidersHorizontal, X } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

/** Labelled field in the drawer; `wide` spans both columns. */
export const FilterField = ({ label, wide = false, children }) => (
  <div className={cn("min-w-0", wide && "col-span-2")}>
    {label && <p className="mb-1 text-xs font-medium text-gray-500">{label}</p>}
    {children}
  </div>
);

/** Titled two-column group of filter fields. */
export const FilterSection = ({ title, children }) => (
  <section className="border-b border-gray-100 px-5 py-4 last:border-b-0">
    <h3 className="mb-3 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
      {title}
    </h3>
    <div className="grid grid-cols-2 gap-3">{children}</div>
  </section>
);

/** Filters button and right-side drawer; picks apply only on Apply. */
const FiltersDrawer = ({
  count = 0,
  open,
  onOpenChange,
  onApply,
  onReset,
  children,
}) => (
  <>
    <Button
      type="button"
      variant="outline"
      onClick={() => onOpenChange(true)}
      className={cn(
        "h-9 shrink-0 gap-2 font-normal",
        count > 0 &&
          "border-[#7f7ad5] bg-[#efedfc] text-[#3c3489] hover:bg-[#e6e3fa]"
      )}
    >
      <SlidersHorizontal className="h-4 w-4" />
      {count > 0 ? `Filters · ${count}` : "Filters"}
    </Button>
    <Drawer
      anchor="right"
      open={open}
      onClose={() => onOpenChange(false)}
      disableEnforceFocus
      sx={{ zIndex: 999 }}
      PaperProps={{ sx: { width: { xs: "100%", sm: 400 } } }}
    >
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
          <h2 className="text-base font-semibold text-gray-900">Filters</h2>
          <button
            type="button"
            aria-label="Close filters"
            onClick={() => onOpenChange(false)}
            className="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">{children}</div>
        <div className="flex items-center gap-2 border-t border-gray-200 px-5 py-3">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-8 px-2 text-xs text-gray-500 hover:text-gray-700"
            onClick={onReset}
          >
            Reset
          </Button>
          <div className="ml-auto flex gap-2">
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="h-8"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button type="button" size="sm" className="h-8" onClick={onApply}>
              Apply filters
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  </>
);

export default FiltersDrawer;
